import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useStore } from '#client/providers/Provider.tsx';
import { setNewLocale } from '#client/utils/locale.ts';
import { Locale } from '#shared/locale.ts';
import { paths } from '#shared/paths.ts';
import {
	onBreadcrumbClick,
	onLanguageSelect,
	setAvailableLanguages,
	setBreadcrumbs,
} from '@navikt/nav-dekoratoren-moduler';
import { getBreadcrumbsFromPathname } from '#shared/breadcrumbs.ts';

export const DecoratorWidgets = () => {
	const { pathname } = useLocation();
	const pathnamePrefixed = `${paths.kontaktOss.forside}${pathname}`;
	const navigate = useNavigate();
	const [{ locale }, dispatch] = useStore();

	useEffect(() => {
		onLanguageSelect((breadcrumb) => {
			setNewLocale(breadcrumb.locale as Locale, dispatch);
		});

		onBreadcrumbClick((breadcrumb) => {
			navigate(breadcrumb.url.replace(paths.kontaktOss.forside, ''));
		});
	}, []);

	// Set languages in decorator
	useEffect(() => {
		const subPath = pathnamePrefixed.replace(`${paths.kontaktOss.forside}/${locale}`, '');

		setAvailableLanguages([
			{
				locale: 'nb',
				url: `${paths.kontaktOss.forside}/nb/${subPath}`,
				handleInApp: true,
			},
			{
				locale: 'nn',
				url: `${paths.kontaktOss.forside}/nn/${subPath}`,
				handleInApp: true,
			},
			{
				locale: 'en',
				url: `${paths.kontaktOss.forside}/en/${subPath}`,
				handleInApp: true,
			},
		]);
	}, [pathnamePrefixed, locale]);

	// Set breadcrumbs in decorator
	useEffect(() => {
		const breadcrumbs = getBreadcrumbsFromPathname(pathnamePrefixed, locale);

		setBreadcrumbs([...breadcrumbs]);
	}, [pathnamePrefixed, locale]);

	return null;
};
